import "./legal-dialog.scss"

import CtvDialogModal from "./dialog-modal"
import showdown from "showdown";


export default class CtvLegalDialog extends CtvDialogModal {

    static get DomTag() { return  'ctv-legal-dialog'; }

    static get LANGS() {
        return {
            "it": "it",
            "en": "en"
        }
    }

    static get properties() {
		return {
            content: {type: String},
            urls: {type: String}
		};
    }
    constructor() {
		super();

        this.content = "...";

        this.SetButton(this.Ln("Close"), () => { this.Ok()});
    }

    GetTranslations() {
        return {
            "Close": {
                "it": "Chiudi",
                "en": "Close"
            },
            "Loading": {
                "it": "Caricamento",
                "en": "Loading"
            },
            "Terms and Conditions": {
                "it": "Termini e Condizioni",
                "en": "Terms and Conditions"
            },
            "Privacy": {
                "it": "Privacy",
                "en": "Privacy"
            },
            "Cookies": {
                "it": "Cookies",
                "en": "Cookies"
            }
        }
    }

    GetContent() {
        let w = this.ShowWaiter(this.Ln("Loading") + "...");
        Promise.all(
            this.urls.split(",").map(
                url => fetch(url)
                .then(res => res.text())
            )
        )
        .then((res) => {
            let print = "";
            res.forEach(text => {
                print += text;
            })
            var converter = new showdown.Converter({ tables: true });
            this.body = this.ToHtml(converter.makeHtml(print));
        })
        .finally(() => {
			w.remove()
        });
    }

    Init() {
        super.Init();
        this.GetContent();
    }

    static ShowTerms(urls) {
        let elDlg = new CtvLegalDialog();
        let lang = elDlg.lang;

        if(!CtvLegalDialog.LANGS[lang])
            lang = "it"
        
        elDlg.title_label = elDlg.Ln("Terms and Conditions");
        if (urls)
            elDlg.urls = urls;
        else
            elDlg.urls = `
                https://legal.cam.tv/legal-docs/terms-and-conditions/current/${lang}/abbo_free.md,
                https://legal.cam.tv/legal-docs/terms-and-conditions/current/${lang}/abbo_basic.md,
                https://legal.cam.tv/legal-docs/terms-and-conditions/current/${lang}/abbo_advanced.md,
                https://legal.cam.tv/legal-docs/terms-and-conditions/current/${lang}/abbo_professional.md
            `;

		return CtvDialogModal.Show(elDlg);
    }

    static ShowPrivacy(urls){
        let elDlg = new CtvLegalDialog();
        let lang = elDlg.lang;
        
        if(!CtvLegalDialog.LANGS[lang])
            lang = "it"

        elDlg.title_label = elDlg.Ln("Privacy");

        if (urls)
            elDlg.urls = urls;
        else
		    elDlg.urls = `https://legal.cam.tv/legal-docs/privacy/current/${lang}/privacy.md`;

		return CtvDialogModal.Show(elDlg);
    }

    static ShowCookies(urls){
        let elDlg = new CtvLegalDialog();
        let lang = elDlg.lang;
        
        if(!CtvLegalDialog.LANGS[lang])
            lang = "it"

        elDlg.title_label = elDlg.Ln("Cookies");

        if (urls)
            elDlg.urls = urls;
        else
		    elDlg.urls = `https://legal.cam.tv/legal-docs/cookies/current/${lang}/cookies.md`;

		return CtvDialogModal.Show(elDlg);
    }
}

CtvLegalDialog.RegisterElement();

window.CtvLegalDialog = CtvLegalDialog;